//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';

export default Vue.extend({
  props: {
    data: {
      type: Object,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
    sectionKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  mounted() {
    this.inputValue = this.value ? this.value.text : '';
    this.$refs.input.focus();
  },
  destroyed() {
    // this.saveValue();
  },
  methods: {
    saveValue(focusNext = true) {
      const value = this.inputValue || '';
      if (value) {
        this.$emit('save', {
          focusNext,
          key: this.sectionKey,
          value: {
            textValue: value + '',
            text: value + '',
          },
        });
      }
    },
  },
});
